var l = function(r) {
  return null;
};
l.displayName = "Cell";
export {
  l as Cell
};
